import * as React from "react";
import './GenericPassenger.scss';
import {GenericPassengerController} from "../../../Controller/3DController/GenericPassengerController";
import { trackVisualFeature } from "../../../Controller/Tracking";
import { ChevronLeft, ChevronRight, Close } from '../Icons/Icons';


interface Props{
    genericPassengerController:GenericPassengerController;
    exit:()=>void
}

interface State{
    height: number,
    weight: number
}

let firstHeightChange:boolean = true;
let firstWeightChange:boolean = true; 

export class GenericPassenger extends React.Component<Props,State> {

    constructor(props:Props){
        super(props);
        this.state = {
            height: props.genericPassengerController.height,
            weight: props.genericPassengerController.weight
        };
    }

    componentDidMount(){
    }

    componentWillUnmount(){
    }

    percentToValue(p:number, min:number, max: number) {
        return (p/100) * (max - min) + min;
    }
    valueToPercent(v:number, min:number, max:number) {
        return (v - min) / ( max - min ) * 100;
    }

    onFirstHeightChange():void {
        if (firstHeightChange) {
            firstHeightChange = false;
            trackVisualFeature("generic avatar change height");
        }
    }

    onFirstWeightChange():void {
        if (firstWeightChange) {
            firstWeightChange = false;
            trackVisualFeature("generic avatar change weight");
        }
    }

    render(){
        let hpercent = this.valueToPercent(this.props.genericPassengerController.height, GenericPassengerController.HEIGHT_MIN, GenericPassengerController.HEIGHT_MAX);
        let wpercent = this.valueToPercent(this.props.genericPassengerController.weight, GenericPassengerController.WEIGHT_MIN, GenericPassengerController.WEIGHT_MAX);
        return(
            <div className={"generic-passenger-holder"}>
                <div className={"generic-passenger-holder-div"}>
                    <div className={"generic-passenger-slider"}>
                        <div className={"generic-passenger-icon"} onClick={()=>{}}><img src={`./${HASH}/Icons_Png/Dummy_height.svg`}/></div>
                        <div className={"slider-wrapper"}>
                                <input 
                                    type="range"
                                    min="0"
                                    max="100"
                                    className="slider-intensity"
                                    value={hpercent}
                                    onMouseDown={() => this.onFirstHeightChange()}
                                    onTouchStart={() => this.onFirstHeightChange()}
                                    onChange={(e)=>{
                                        let height = this.percentToValue(+e.target.value, GenericPassengerController.HEIGHT_MIN, GenericPassengerController.HEIGHT_MAX);
                                        this.props.genericPassengerController.height = height;
                                        this.setState({height})
                                    }}/>
                                <div className={"slider-thumb"} style={{"left":( hpercent )+"%", transform: "translateY(-50%) translateX(-" + ( hpercent ) + "%)"}}>
                                    <span className={"thumb-background"}></span>
                                    <span></span>
                                </div>
                            </div>
                        <div className={"generic-passenger-slider-text"}>{Number(this.props.genericPassengerController.height).toFixed(2)} m</div>
                    </div>

                    <div className={"generic-passenger-slider"}>
                        <div className={"generic-passenger-icon generic-passenger-icon-adjust"} onClick={()=>{}}><img src={`./${HASH}/Icons_Png/Dummy_width.svg`}/></div>
                        <div className={"slider-wrapper"}>
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    className="slider-intensity"
                                    value={wpercent}
                                    onMouseDown={() => this.onFirstWeightChange()}
                                    onTouchStart={() => this.onFirstWeightChange()}
                                    onChange={(e)=>{
                                        let weight = this.percentToValue(+e.target.value, GenericPassengerController.WEIGHT_MIN, GenericPassengerController.WEIGHT_MAX);
                                        this.props.genericPassengerController.weight = weight;
                                        this.setState({weight})
                                    }}/>
                                <div className={"slider-thumb"} style={{"left":( wpercent )+"%", transform: "translateY(-50%) translateX(-" + ( wpercent ) + "%)"}}>
                                    <span className={"thumb-background"}></span>
                                    <span></span>
                                </div>
                            </div>
                        <div className={"generic-passenger-slider-text"}>{Number(this.props.genericPassengerController.weight).toFixed(0)} kg</div>
                    </div>
                </div>

                <div className={"generic-passenger-exit-row"}>
                    <div className={"generic-passenger-clean"}
                        onClick={() => this.props.genericPassengerController.locationRotateLeft()}
                    >
                        <ChevronLeft />
                    </div>
                    <div className={"generic-passenger-off"} onClick={()=>{this.props.exit()}}>
                        <Close />
                    </div>
                    <div className={"generic-passenger-clean"}
                        onClick={() => this.props.genericPassengerController.locationRotateRight()}
                    >
                        <ChevronRight />
                    </div>
                </div>
            </div>
        )
    }
}
